<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <v-row>
        <v-col md="9" cols="12">
          <ModuleHeader>Administrar aplicaciones</ModuleHeader>
        </v-col>
      </v-row>

      <uv-data-table :config="config" :data="apps" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    </div>

  </div>
</template>

<script>
import uvDataTable from "../../MainComponents/DataTable.vue";


export default {
  name: "AppsConfigCRUD",
  components: {
    uvDataTable,

  },
  props: [],
  data() {
    return {

      apps: [],

      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Bahias de salida",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Invalidar Cache",
            icon: "lni lni-trash",
            buttonId: "deleteCache",
          },
          /*{
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarBahia",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteBahia",
            require: true,
          },*/
        ],
        fields: [
          {
            text: "Nombre",
            value: "nm",
          },

        ],
      },
      idSelected: "",
    };
  },
  computed: {

  },
  methods: {
    async getApps() {
      let apps = [];
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "APP/Aplicaciones"
      );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          apps.push({ id: element[0], ...element[1] });
        });
        this.apps = apps;
      } else {
        this.apps = []
      }
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createBahia(data);
      } else {
        this.updateBahia(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;

      if (buttonId == "deleteCache") {

        this.deleteCache(idSelected[0]);
      }
    },
    createBahia(data) {
      data.ia = this.rvaDepto
      data.od = Number(data.od)
      this.$swal({
        title: "¿Deseas guardar la bahia?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Bahias-createBahia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La bahia se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getBahias()
            });
          } else {
            this.$swal("Error saving bahia", result.value.data.error, "error");
          }
        }
      });
    },
    updateBahia(data) {
      data.ia = this.rvaDepto
      data.od = Number(data.od)
      this.$swal({
        title: "¿Deseas editar la bahia?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Bahias-updateBahia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La bahia se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getBahias()
            });
          } else {
            this.$swal("Error saving bahia", result.value.data.error, "error");
          }
        }
      });
    },
    deleteCache(id) {
      let datos = { App: id };
      this.$swal({
        title: "¿Deseas eliminar la cache de esta aplicacion?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("APP-Apps-invalidarCache", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal("La cache se elimino correctamente", "", "success");
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function () { },
  mounted: async function () {
    this.getApps();
  },
};
</script>
